export default function getResource(label) {
    const resources = {
        showComparison: 'Afficher la comparaison',
        hideComparison: 'Masquer la comparaison'
    };

    return resources[label];
}
